import { t } from '@lingui/core/macro'
import styled from '@emotion/styled'
import { Info } from '@mui/icons-material'
import { Tooltip } from '@mui/material'

const StyledSpan = styled.span`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 12px;

  svg {
    margin-left: 2px;
  }
`

interface Props {
  title: string
}

export const TitleLabel = ({ title }: Props) => (
  <StyledSpan>
    {title}
    {title === 'Properties' && (
      <Tooltip title={t`System-generated data for each row`} placement="top" arrow>
        <Info color="disabled" fontSize="small" />
      </Tooltip>
    )}
  </StyledSpan>
)
